import React from 'react'
import Changes from '../../../../changes/Changes'
import { useEffect } from 'react'
import { useState } from 'react'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { getChangesSeriesesAPI } from '../../../../../api/pack/seriesAPI'
import MySpiner from '../../../../UI/spiner/MySpiner'

const SeriesChanges = ({ seriesId, setOpen }) => {

	const [changes, setChanges] = useState([])
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState('')

	useEffect(() => {
		if (seriesId) {
			getChanges()
		}
	}, [seriesId])

	const getChanges = () => {
		setLoading(true)
		setError('')
		getChangesSeriesesAPI({ seriesId }).then(data => {
			setChanges(data)
			setLoading(false)
		}).catch(e => {
			setError(responseError(e))
			setLoading(false)
		})
	}

  return (
	<>
		{
			error ?
				<div className='error'>
					{error}
				</div>
			: 
			loading ?
				<MySpiner />
			:
				<Changes 
					changes={changes}
				/>
		}
	</>
  )
}

export default SeriesChanges